import React from 'react';
import { Link } from 'react-router-dom';

import { Row } from '../../components/Grid/Row';
import { Card } from '../../components/Card';
import { Column } from '../../components/Grid/Column';

// apollo
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

const GET_FAVORITES = gql`
  query servicesByNames($favoritesArray: [String!]!) {
    servicesByNames(name: $favoritesArray) {
      name
      git_url

    }
  }
`;

function FavoritesListing(favoritesArray: string[]) {
  const { loading, error, data } = useQuery(GET_FAVORITES, {
    variables: { favoritesArray },
  });

  if (loading) return null;
  if (error) return `Error! ${error}`;
  const services = data.servicesByNames;
  if(!services){
    return null;
  }

  return (
    <Row className="pad-y-l">
      <Column width={3}>
        <h2>Favorites</h2>
      </Column>
      <Column width={9}>
        {services.map((service: any) => {
          return (
            <Card key={service.git_url}>
              <Link to={`/services/${service.name}`}>{service.name}</Link>
            </Card>
          )
        })}
      </Column>
    </Row>
  );
}

interface FavoritesProps {
  localFavorites: string;
}

const Favorites: React.FC<FavoritesProps> = props => {
  const favoritesArray = JSON.parse(props.localFavorites);
  return <div>{FavoritesListing(favoritesArray)}</div>;
};

export default Favorites;

